export default __webpack_public_path__ + "./images/recipes-3.png";